export enum SkillStatusEnum {
    TO_DISCOVER = 'TO_DISCOVER',
    STARTED = 'STARTED',
    CONFIRMED = 'CONFIRMED',
    MASTERED = 'MASTERED',
}

export type Skill = { id: number; name: string; status: SkillStatusEnum; comment: string; isFavorite: boolean }
